
<div class="loader" [hidden]="status != LOADING">
    <div class="dimmed">
        <div class="dimmed_box"></div>
        <div class="dimmed_box"></div>
    </div>
</div>
<div *ngIf="status == DONE">
    <ul class="version-related-item">
        <li *ngFor="let version of versions">
            <core-version-files-list-checkbox
              [version]="version"
              [feedbacks]="getFeedbacks(version)"
              [selected]="selected"
              (selectedChange)="onChange($event);"
              [disabled]="disabled"
             ></core-version-files-list-checkbox>
        </li>
    </ul>
</div>
